import { useMutation } from "@tanstack/react-query";
import { api, reachable } from "@/lib/api";
import { openStripeTab, sendToStripe } from "./resume-after-checkout";

/**
 * Stripe's billing page, where a player changes or cancels a web subscription and finds invoices
 * and receipts. It opens in a new tab, or in this one when the browser blocks the tab.
 * `onOpened` runs once the new tab has it.
 */
export function useBillingPortal(onOpened?: () => void) {
  const portal = useMutation({
    mutationFn: (_tab: Window | null) => reachable(api.payments.billingPortalSessions.create()),
    onSuccess: ({ url }, tab) => {
      sendToStripe(tab, url);
      if (tab && !tab.closed) onOpened?.();
    },
    onError: (_error, tab) => tab?.close(),
  });
  return { portal, openBilling: () => portal.mutate(openStripeTab()) };
}
